import Head from "next/head";
import { make as ItemsInfoPage } from "../../../src/info/ItemsInfoPage.bs";

export default function ItemsInfo({ itemId }) {
  return (
    <>
      <Head>
        <title>Items Set 4.5 TFT Info & Items Chart</title>
      </Head>
      <ItemsInfoPage set={46} itemId={itemId || undefined} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      itemId: null,
    },
    revalidate: 3600,
  };
}
